import { createFileRoute, Navigate } from "@tanstack/react-router"

export const Route = createFileRoute("/_authenticated/_organization/content/")({
  component: () => <Navigate to="/content/documents" />,
})
